<template>
<div id="verify-account">
  <Header />
  <v-container class="verify-account" fluid fill-height>
    <v-row>
      <v-col sm="12" md="6" offset-md="3" xl="6" offset-xl="3" align="center">
        <v-card>
            <v-row class="primary" no-gutters>
              <v-col cols="12" class="pt-3">
                <a @click="goToPath('/')">
                  <v-img height="auto" width="80" src="@/assets/zf-logo-white-cirle.png"/>
                </a>
              </v-col>
            </v-row>
            <v-row no-gutters class="text-center primary white--text py-3">
              <v-col cols="12">
                <p class="text-h5 mb-0">Verify your Supplier Account</p>
              </v-col>
            </v-row>
          <v-card-text>
            <v-card-title class="justify-center">
            </v-card-title>
            <p class="text-subtitle-1">We have sent you an e-mail to <b>{{user.email}}</b> containing a link for your account verification.
              <br> Please follow the link to verify your account.</p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
  <Footer />
</div>
</template>

<script>
import { auth } from '@/firebaseConfig'
import { goToPath } from '@/mixins'

export default {
  components: {
    Header: () => import('@/components/Header'),
    Footer: () => import('@/components/Footer')
  },
  data() {
    return {
      user: null
    }
  },
  computed: {
    // ...mapGetters(['user'])
  },

  created() {
    this.user = auth.currentUser
    if (!this.user) goToPath('/')
    if (this.user.isVerified) goToPath('/verified')
  }
}
</script>

<style scoped>
.verify-account {
  background-image: linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.6)),
    url('../../assets/about/rwanda-farmer.jpg');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

#verify-account {
  display: contents;
}
</style>
